export default __webpack_public_path__ + "8d3f358381e6562c7b7258384b9d71f7.png";